module.exports = __webpack_public_path__ + "Poppins-Regular.e212f84086965da44a6c.ttf";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/src/assets/fonts/Poppins-Regular.ttf
// module id = ../../../../../src/assets/fonts/Poppins-Regular.ttf
// module chunks = 2